/**
 * The Gathering — canonical Winter 2026 wordmark lockup.
 *
 * PER OWNER (Feb 2026, latest approval): a single unified image
 * asset cropped directly from the owner-supplied Winter 2026
 * reference. NO text reconstruction. NO redrawing / retyping /
 * restyling / reinterpreting. NO per-letter alignment. The image
 * itself is the wordmark.
 *
 * Behaviour:
 *   • Identical asset in Arabic and English (the wordmark itself is
 *     English; the same image renders in both modes).
 *   • Centred as one composition; scaled responsively only as a
 *     whole, preserving its natural aspect ratio.
 *   • Rendered on a `dir="ltr"` <h1> so the lockup stays Latin-
 *     ordered inside RTL pages.
 *   • The gold circle visible near the top-right of "The" is the
 *     dot of the "i" in "Gathering" produced by the approved
 *     overlap in the reference — preserved as pixels; NOT treated
 *     as a separate period.
 */
import React from "react";

const WORDMARK_SRC = "/logos/the-gathering-wordmark.png";
// Natural asset dimensions of the crop from the approved reference:
//   696 × 236  → aspect ratio 2.9491…
const NATURAL_W = 696;
const NATURAL_H = 236;

export const HeroWordmark = ({ testId = "hero-title" }) => {
  return (
    <h1
      dir="ltr"
      lang="en"
      data-testid={testId}
      className="mx-auto mb-6 flex justify-center"
      style={{ padding: 0 }}
    >
      <img
        src={WORDMARK_SRC}
        alt="The Gathering"
        width={NATURAL_W}
        height={NATURAL_H}
        draggable={false}
        data-testid={`${testId}-image`}
        style={{
          display: "block",
          width: "min(92vw, 640px)",
          height: "auto",
          maxWidth: "100%",
          userSelect: "none",
        }}
      />
    </h1>
  );
};

export default HeroWordmark;
